// extracted by mini-css-extract-plugin
export default {"tr":"reports_tr__58+tE","table":"reports_table__ltyyx","subHead":"reports_subHead__UZ0zv","subHead1":"reports_subHead1__lsQi-","region":"reports_region__wxDuS"};